import { render, staticRenderFns } from "./DocumentEditorPage.vue?vue&type=template&id=24ed39e3&scoped=true"
import script from "./DocumentEditorPage.vue?vue&type=script&lang=js"
export * from "./DocumentEditorPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditorPage.vue?vue&type=style&index=0&id=24ed39e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed39e3",
  null
  
)

export default component.exports